export const REPORT_WINDOW_OPTIONS = [
	{
		code: 'monthly',
		name: 'Monthly',
		shortLabel: 'This month',
		overviewTitle: 'Monthly Overview',
		description: 'Current calendar month only',
	},
	{
		code: 'annual',
		name: 'Annual',
		shortLabel: 'This year',
		overviewTitle: 'Annual Overview',
		description: 'All plates logged in the current calendar year',
	},
	{
		code: 'decennial',
		name: 'Decennial',
		shortLabel: 'This decade',
		overviewTitle: 'Decennial Overview',
		description: 'All plates logged in the current calendar decade',
	},
];

/**
 * @param {string} code
 * @returns {typeof REPORT_WINDOW_OPTIONS[number]}
 */
export function getReportWindowOption(code) {
	return REPORT_WINDOW_OPTIONS.find((opt) => opt.code === code) || REPORT_WINDOW_OPTIONS[0];
}
